import parse from "html-react-parser";
import { t } from "i18next";
import React, { useMemo } from "react";

import useCheckDevice from "@repo/shopifyV2/hooks/useCheckDevice";
import useServerTime from "@repo/shopifyV2/hooks/useServerTime";

import Button from "@atoms/Button";
import Dim from "@atoms/Dim";
import Icon from "@atoms/Icon";
import Image from "@atoms/Image";
import Link from "@atoms/Link";

import { useLayoutStore } from "@store/layout";

export default function Popup() {
  const { isPC } = useCheckDevice();
  const { popup, openPopup } = useLayoutStore();

  const { serverTime, isLoading: isServerTimeLoading } = useServerTime();

  // 노출 기간(start_date ~ end_date) 안에 있는지 확인, 값이 없거나 유효하지 않은 날짜면 해당 조건은 무시
  const isPopupPeriod = useMemo(() => {
    const now = serverTime.getTime();
    const startTime = popup?.startDate?.getTime();
    const endTime = popup?.endDate?.getTime();

    if (startTime && now < startTime) return false;
    if (endTime && now > endTime) return false;

    return true;
  }, [popup, serverTime]);

  const handleHideToday = () => {
    const midnight = new Date();
    midnight.setHours(24, 0, 0, 0);
    localStorage.setItem("popup", JSON.stringify(midnight.getTime()));
    openPopup(null);
  };

  // 서버 시간을 받아오기 전에는 노출 기간 밖 팝업이 잠깐 보이는 것을 방지하기 위해 렌더링하지 않음
  if (isServerTimeLoading || !isPopupPeriod) return null;

  return (
    <div className="relative">
      <section className="center pc:w-1/3 fixed z-80 flex max-h-[calc(100%-2rem)] w-[calc(100%-2rem)] flex-col bg-white shadow lg:w-1/4">
        <div className="absolute top-5 right-5 z-10">
          <Button
            as="wrapper"
            onClick={() => {
              openPopup(null);
            }}
          >
            {isPC ? "Close" : <Icon name="Close" />}
          </Button>
        </div>
        {popup?.image ? <Image height={popup.image.height || 500} src={popup.image.url} width={popup.image.width || 400} /> : null}

        <div className="flex flex-col gap-5 p-4 leading-4.5">
          <h2 className="text-title">{parse(popup?.title || "")}</h2>
          <div className="flex flex-col gap-5">
            {parse(popup?.description || "")}

            <div className="pc:gap-1 flex gap-2.5">
              <Button as="square" className="w-full" onClick={handleHideToday} variant="secondary">
                {t("popup_close")}
              </Button>
              {popup?.buttonText && popup?.url ? (
                <Link as="square" className="flex! w-full items-center justify-center" href={popup.url}>
                  {popup.buttonText}
                </Link>
              ) : null}
            </div>
          </div>
        </div>
      </section>
      <Dim
        onClick={() => {
          openPopup(null);
        }}
      />
    </div>
  );
}
